import {
  Login,
  Otp,
  Signup,
  TripDetails,
  CustomerHelpFAQ,
  CustomerPolicy,
  CustomerAboutUs,
  CustomerTAC,
  CommonRideView,
  Home,
  ConfirmPay,
  CancellationPolicy,
  Help,
  Safety,
  RideDetails,
  MyRideView,
  PaymentMethod,
  PaymentFailed,
  Dashboard,
  CancelReason,
  TripStatus,
  Profile,
} from "./components";
import Layout from "layout/Layout";

export const routeConfigAuth = [
  { path: "/", component: CommonRideView, layout: Layout, isAuth: false },
  { path: "/login", component: Login, layout: null, isAuth: false },
  { path: "/otp", component: Otp, layout: null, isAuth: false },
  { path: "/signup", component: Signup, layout: null, isAuth: false },

];

export const routeConfigCommon = [
  {
    path: "shareTrip",  // No path parameters
    component: TripDetails,
    layout: null,
    isAuth: false,
  },
  { path: "faq", component: CustomerHelpFAQ, layout: null, isAuth: false },
  {
    path: "privacy-policy",
    component: CustomerPolicy,
    layout: null,
    isAuth: false,
  },
  {
    path: "cancellation-policy",
    component: CancellationPolicy,
    layout: null,
    isAuth: false,
  },
  {
    path: "termsandconditions",
    component: CustomerTAC,
    layout: null,
    isAuth: false,
  },
  { path: "aboutus", component: CustomerAboutUs, layout: null, isAuth: false },
  { path: "/help", component: Help, layout: null, isAuth: false },
  { path: "/safety", component: Safety, layout: Layout, isAuth: false },
];

export const routeConfigCustomer = [
  { path: "/history", component: CommonRideView, layout: null, isAuth: false },
  { path: "/home", component: Dashboard , layout: Layout, isAuth: true },
  { path: "/ride", component:Home, layout:Layout, isAuth:true},
  {
    path: "/rideDetails",
    component: ConfirmPay,
    layout: Layout,
    isAuth: true,
  },
  { path: "/helpFaq", component: Help, layout: Layout, isAuth: true },
  { path: "/safety", component: Safety, layout: Layout, isAuth: true },
  { path: "/myride", component: MyRideView, layout: Layout, isAuth: true },
  {
    path: "/myride/details",
    component: RideDetails,
    layout: Layout,
    isAuth: true,
  },
  { path: "/payment", component:PaymentMethod,layout:Layout, isAuth:true},
  { path:"/confirmRide",component:TripStatus,layout:Layout,isAuth:true },
  { path:"/paymentFailed",component:PaymentFailed,layout:Layout,isAuth:true },
  { path:"/cancelReason",component:CancelReason, layout:Layout, isAuth:true},
  { path:"/profile",component:Profile,layout:Layout,isAuth:true },

];
